//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SlideUpDown from 'vue-slide-up-down'; // xD

import { version } from '../../package.json';

export default {
  components: {
    SlideUpDown
  },
  props: {
    /**
     * Estado abierto/cerrado del contenido
     */
    active: Boolean
  },
  data: () => ({
    version
  }),
  methods: {
    onOpen(type) {
      this.$emit('open', { type });
    },
    onClose(type) {
      this.$emit('close', { type });
    }
  }
};
